var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from "react";
import { IndexRedirect, NestedRoute, PartialRoute, withPartialRoute } from "@irati/utils/history/routing";
import AppContainer from "@irati/ui/src/AppContainer";
import { HasPermissionTo } from "@irati/utils/permissions";
import mainTheme from "@irati/ui/src/global/theme";
import DealInfo from "../../containers/DealInfo";
import Deals from "../../containers/Deals/Deals";
import DealSuccess from "../../containers/DealSuccess/DealSuccess";
import RedeemProduct from "../../containers/RedeemProduct";
import RedeemEmail from "../../containers/RedeemDetails";
import HomePage from "../../containers/HomePage";
import PerksContainer from "../containers/PerksContainer";
import PaymentOrder from "../../containers/PaymentOrder";
import PaymentError from "../../containers/PaymentError/PaymentError";
import PaymentComplete from "../../containers/PaymentComplete/PaymentComplete";
import Account from "./account";
var Info = function (_a) {
    var url = _a.match.url;
    return (React.createElement(React.Fragment, null,
        React.createElement(NestedRoute, { match: url, exact: true, path: "/:urlSlug/redeem/:sagaUuid", component: RedeemProduct, title: "Redeem" }),
        React.createElement(NestedRoute, { match: url, path: "/:urlSlug/redeem/update/:sagaUuid", component: RedeemEmail, title: "Update Details" }),
        React.createElement(NestedRoute, { match: url, exact: true, path: "/:urlSlug/pay/:sagaUuid", title: "Payment", component: PaymentOrder }),
        React.createElement(NestedRoute, { match: url, path: "/:urlSlug/pay/:sagaUuid/error", title: "Payment error", component: PaymentError }),
        React.createElement(NestedRoute, { match: url, path: "/:urlSlug/payment-redirect/:sagaUuid/", title: "Payment complete", component: PaymentComplete }),
        React.createElement(NestedRoute, { match: url, path: "/:urlSlug/success/:sagaUuid", title: "Deal Redeemed", component: DealSuccess }),
        React.createElement(NestedRoute, { match: url, exact: true, path: "/:urlSlug", title: "Deal", component: DealInfo })));
};
var PerksClient = /** @class */ (function (_super) {
    __extends(PerksClient, _super);
    function PerksClient() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PerksClient.prototype.render = function () {
        var _a = this.props, path = _a.path, location = _a.location;
        var isPerksAccount = location.pathname.includes("/perks/account");
        return (React.createElement(AppContainer, { mainBackground: isPerksAccount && mainTheme.colors.greys.white },
            React.createElement(HasPermissionTo, { permissions: "perks" },
                React.createElement(PerksContainer, null,
                    React.createElement(NestedRoute, { match: path, path: "/account", component: Account }),
                    React.createElement(NestedRoute, { match: path, path: "/categories/:category?", title: "Deals", component: Deals }),
                    React.createElement(PartialRoute, { match: path, path: "/info", component: Info }),
                    React.createElement(PartialRoute, { match: path, path: "/discover", title: "Home", component: HomePage }),
                    React.createElement(IndexRedirect, { match: { url: path }, to: "/discover" })))));
    };
    return PerksClient;
}(Component));
export default withPartialRoute(PerksClient);
